function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!content) {
    if (el) el.remove()
    return
  }
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!href) {
    if (el) el.remove()
    return
  }
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function upsertJsonLd(data) {
  const id = 'page-json-ld'
  let el = document.getElementById(id)
  if (!data) {
    if (el) el.remove()
    return
  }
  if (!el) {
    el = document.createElement('script')
    el.type = 'application/ld+json'
    el.id = id
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
}

export function setPageMeta({
  title,
  description,
  keywords,
  canonical,
  jsonLd,
  ogType = 'website',
  ogImage = ''
} = {}) {
  if (title) document.title = title
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'keywords', keywords)
  upsertLink('canonical', canonical)
  upsertMeta('property', 'og:type', ogType || '')
  upsertMeta('property', 'og:title', title || '')
  upsertMeta('property', 'og:description', description || '')
  upsertMeta('property', 'og:url', canonical || '')
  upsertMeta('property', 'og:site_name', '算力百科')
  upsertMeta('property', 'og:image', ogImage || '')
  upsertMeta('name', 'twitter:card', ogImage || canonical ? 'summary' : '')
  upsertJsonLd(jsonLd)
}

export function clearPageMeta(defaultTitle = '算力百科') {
  document.title = defaultTitle
  upsertMeta('name', 'description', '')
  upsertMeta('name', 'keywords', '')
  upsertLink('canonical', '')
  upsertMeta('property', 'og:type', '')
  upsertMeta('property', 'og:title', '')
  upsertMeta('property', 'og:description', '')
  upsertMeta('property', 'og:url', '')
  upsertMeta('property', 'og:site_name', '')
  upsertMeta('property', 'og:image', '')
  upsertMeta('name', 'twitter:card', '')
  upsertJsonLd(null)
}
